import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { removeSystemFieldNamePrefix } from '../../utils/Utilities';
import { RequiredMarker } from '../RequiredMarker';

export const CustomFieldLabel = ({
  fieldName,
  isSystem = false,
  fontStyle = 'italic',
  required = false,
  originalFieldName,
  ...props
}: {
  fieldName: string;
  isSystem: boolean;
  fontStyle?: string;
  required?: boolean;
  originalFieldName?: string;
}) => {
  const { t } = useTranslation('translation');

  const displayedName = isSystem ? removeSystemFieldNamePrefix(fieldName) : fieldName;

  // A feedback form can relabel a field for that form only, so the label shown here is not
  // necessarily the field's own name. Surface the original only when it actually differs —
  // otherwise the tooltip would just echo the visible text.
  const original = originalFieldName
    ? isSystem
      ? removeSystemFieldNamePrefix(originalFieldName)
      : originalFieldName
    : undefined;
  const renamed = original !== undefined && original !== displayedName;

  if (isSystem) {
    return (
      <Tooltip
        title={
          renamed
            ? t(($) => $.ideaManagement.general.systemFieldWithNameToolTip, { name: original })
            : t(($) => $.ideaManagement.general.systemFieldToolTip)
        }
        arrow
      >
        <span
          className="fs-exclude"
          data-dd-action-name="FIM 3 System Custom Field - tooltip label redacted"
          style={{ fontStyle: fontStyle || 'italic' }}
          {...props}
        >
          {displayedName}
          {required && <RequiredMarker />}
        </span>
      </Tooltip>
    );
  }

  const label = (
    <span
      className="fs-exclude"
      data-dd-action-name="FIM 3 Custom Field - label redacted"
      data-testid={`fim3-custom-field-label-${fieldName}`}
      {...props}
    >
      {fieldName}
      {required && <RequiredMarker />}
    </span>
  );

  return renamed ? (
    <Tooltip title={original} arrow>
      {label}
    </Tooltip>
  ) : (
    label
  );
};
